import React from "react"

export default ({ title }) => (
  <>
    <h4 className="nr-comment" id="comments">
      {title}
    </h4>
    <div className="comments-area">
      <form
        id="add-a-comment"
        className="add-comment"
        method="post"
        action="?form=comments"
      >
        <h3>add your comment</h3>
        <input
          type="hidden"
          name="form_id"
          value="comments-form-id-1332019-Mar-26"
        />
        <input
          type="hidden"
          name="form_state"
          value="8b3623c26cfcc227fb8924d5fc9820bf1553616031"
        />
        <input
          type="hidden"
          name="comment_post_ID"
          value="133"
          id="comment_post_ID"
        />
        <input
          type="hidden"
          name="comment_parent"
          id="comment_parent"
          value="0"
        />
        <textarea
          name="comment"
          id="comment"
          className="mess validate[required,minSize[5]]"
          placeholder="message..."
        />
        <div className="inputs-wrapper">
          <input
            name="author"
            id="author"
            className="pers validate[required,minSize[3],maxSize[50]]"
            type="text"
            placeholder="name...*"
          />
          <input
            name="email"
            id="email"
            className="pers validate[required,custom[email]]"
            type="text"
            placeholder="email...*"
          />
          <input
            name="url"
            id="url"
            className="pers validate[custom[url]]"
            type="text"
            placeholder="website..."
          />
        </div>
        <input className="comment-button" type="submit" value="submit" />
      </form>
    </div>
  </>
)
